// This file configures the Supabase client using environment variables.
// Credentials are loaded from VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { getSupabaseUrl, getSupabaseAnonKey } from './env';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(getSupabaseUrl(), getSupabaseAnonKey());